import React from 'react';
import classes from './ActivityLogResultDisplayBox.css';

const ActivityLogResultDisplayBox = (props) => (
    <div className={classes.DisplayBox}>
        <div className={classes.DisplayBoxTopBorder}></div>
        <div className={classes.DisplayBoxContent}>
            {props.children}
        </div>
    </div>

);

export default ActivityLogResultDisplayBox;